import { Typogaphy } from 'vnetwork-ui'
import { useTranslation } from 'react-i18next'
import { useNavigate, useLocation } from 'react-router-dom'
import InformationIcon from '@/icons/InformationIcon'
import SecurityIcons from '@/icons/SecurityIcons'
import ContractIcons from '@/icons/ContractIcons'
import ContractPendingIcons from '@/icons/ContractPendingIcons'
import ArrowRightIcons from '@/icons/ArrowRightIcons'
import { ReactNode } from 'react'
import { ScrollText } from 'lucide-react'

interface NavigationCardsProps {
    children?: ReactNode
}

const NavigationCards = ({ children }: NavigationCardsProps) => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const location = useLocation()

    const cards = [
        {
            icon: <InformationIcon className="text-[#9467BD]" />,
            title: t('detailed-information'),
            path: '/account/info',
        },
        {
            icon: <SecurityIcons className="text-primary" />,
            title: t('account-passwork-security'),
            path: '/account/password-security',
        },
        {
            icon: <ContractIcons className="w-6 h-6 text-red-400" />,
            title: t('contracts'),
            path: '/account/contracts',
        },
        {
            icon: <ContractPendingIcons className="w-6 h-6 text-orange-400" />,
            title: t('account-working-process'),
            path: '/account/working-process',
        },
        {
            icon: <ScrollText className="w-6 h-6 text-emerald-500" />,
            title: t('regulations:accepted-regulations', 'Accepted Policies'),
            path: '/account/regulations',
        },
    ]

    const activeCard = cards.find((card) => location.pathname === card.path)
    const otherCards = cards.filter((card) => location.pathname !== card.path)

    return (
        <>
            <div className="grid lg:grid-cols-3 gap-2 mt-4">
                {otherCards.map((card) => (
                    <button
                        key={card.path}
                        type="button"
                        className="bg-white rounded-lg p-4 cursor-pointer hover:shadow-sm transition text-left"
                        onClick={() => navigate(card.path)}
                    >
                        <div className="flex items-center justify-between">
                            <div className="flex items-center gap-2">
                                {card.icon}
                                <Typogaphy size="small" className="font-medium">
                                    {card.title}
                                </Typogaphy>
                            </div>
                            <ArrowRightIcons className="w-6 h-6 text-[#C1DBFF]" />
                        </div>
                    </button>
                ))}
            </div>

            {activeCard && (
                <div className="mt-2 p-4 bg-white rounded-lg">
                    <div className="flex items-center gap-2 mb-4">
                        {activeCard.icon}
                        <Typogaphy size="small" className="font-medium">
                            {activeCard.title}
                        </Typogaphy>
                    </div>
                    {children}
                </div>
            )}
        </>
    )
}

export default NavigationCards
